import { FC } from 'react';
import { TypesCount } from '../../models/SingleUnit';
import { Tooltip } from 'primereact/tooltip';

interface Props {
  value: TypesCount;
}

const SingleUnitCardData: FC<Props> = ({ value }) => {
  const className = value.targetSkillType.toLocaleLowerCase();

  return (
    <>
      <Tooltip target={`.${className}`}>
        {className == 'target'
          ? 'These skills are the primary skills that contribute to the goal of the unit, arranged in order of difficulty.'
          : className == 'support'
          ? 'These are the essential and helpful predecessors for target skills. Completing these skills will increase student readiness to engage with the target skills.'
          : 'These skills are related to the target skills but are not included in the unit progress goal. They apply and reinforce understanding of the unit’s target skills.'}
      </Tooltip>
      <div className={`flex flex-column gap-0 align-items-center ${className}`}>
        <i className={`nc_icon-nc_${className} icon-md pb-2`} />
        <h3>
          {value.count} {value.targetSkillType} Skill&#40;s&#41;
        </h3>
      </div>
    </>
  );
};

export default SingleUnitCardData;
